import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

import { HeaderMenuMilestoneComponent } from './header-menu-milestone.component';

@NgModule({
  declarations: [HeaderMenuMilestoneComponent],
  exports: [HeaderMenuMilestoneComponent],
  imports: [
    CommonModule,
    MatMenuModule,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
    MatDividerModule
  ]
})
export class HeaderMenuMilestoneModule {}
